import React from "react";
import { Button as StyledButton } from "../../routes/main-styles";
import { useSelector } from "react-redux";

function Button({
  children,
  color='#fff',
  backgroundColor,
  onClick = () => {
    console.log("Clicou");
  },
  style={}
}) {
  const { colors } = useSelector((state) => state.appReducer?.app);
  console.log("COLORS:", colors);
  return (
    <StyledButton
      color={color || "#fff"}
      backgroundColor={backgroundColor || colors?.main}
      onClick={onClick}
      style={style}
    >
      {children}
    </StyledButton>
  );
}

export default Button;
